module.exports = __webpack_public_path__ + "static/share.45ae7b31.png";